/* unplugin-vue-components disabled */import { render } from "./error.vue?vue&type=template&id=03b3cc88&scoped=true"
import script from "./error.vue?vue&type=script&lang=js"
export * from "./error.vue?vue&type=script&lang=js"

import "./error.vue?vue&type=style&index=0&id=03b3cc88&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03b3cc88"],['__file',"src/pages/oauth/error.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "03b3cc88"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('03b3cc88', __exports__)) {
    api.reload('03b3cc88', __exports__)
  }
  
  module.hot.accept("./error.vue?vue&type=template&id=03b3cc88&scoped=true", () => {
    api.rerender('03b3cc88', render)
  })

}


export default __exports__